module.exports = __webpack_public_path__ + "img/mealreminder-text-white.c555cd3a.png";